export const nestPath = process.env.REACT_APP_NEST_API_URL;

export const buildingRegisterInfo = `${nestPath}/building-register`;
export const search = `${nestPath}/building-register/search`;
export const items = `${nestPath}/building-register/items`;
export const register = `${nestPath}/building-register`;
export const pdf = `${nestPath}/building-register/pdf`;
export const check = `${nestPath}/building-register/check`;

export const buildingRegisterIssueCount = `${nestPath}/building-register/issue/count`;
